<template>
  <form @submit.prevent="submitForm" class="space-y-6 p-2">
    <div v-for="field in formFields" :key="field.id" class="space-y-2">
      <label
          v-if="field.type !== 'hidden'"
          :for="field.id"
          class="block text-sm font-medium text-gray-700 text-left"
      >
        {{ field.label }}
      </label>
      <input
          v-if="field.type !== 'textarea' && field.type !== 'hidden'"
          :type="field.type"
          :id="field.id"
          :name="field.name"
          v-model="formData[field.name]"
          :required="field.required"
          :placeholder="field.placeholder"
          class="w-full px-4 py-3 bg-white/5 border border-blue-200/20 rounded-xl shadow-sm backdrop-blur-sm
               text-gray-700 placeholder-gray-400
               focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all duration-200"
      />
      <textarea
          v-else-if="field.type === 'textarea'"
          :id="field.id"
          :name="field.name"
          v-model="formData[field.name]"
          :required="field.required"
          :placeholder="field.placeholder"
          rows="5"
          class="w-full px-4 py-3 bg-white/5 border border-blue-200/20 rounded-xl shadow-sm backdrop-blur-sm
               text-gray-700 placeholder-gray-400
               focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all duration-200"
      ></textarea>
      <input
          v-else
          :type="field.type"
          :id="field.id"
          :name="field.name"
          v-model="formData[field.name]"
      />
    </div>

    <div class="flex justify-center">
      <button
          type="submit"
          class="w-full px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600
               hover:from-amber-600 hover:to-amber-700 text-white rounded-xl font-semibold
               shadow-lg hover:shadow-amber-500/25 transition-all transform
               hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed
               disabled:hover:transform-none group"
          :disabled="isSubmitting"
      >
        <span class="flex items-center justify-center">
          <span v-if="isSubmitting">Submitting...</span>
          <span v-else>Submit</span>
          <svg
              v-if="!isSubmitting"
              class="w-4 h-4 ml-2 transform transition-transform group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </span>
      </button>
    </div>

    <Transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="transform -translate-y-2 opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform -translate-y-2 opacity-0"
    >
      <div
          v-if="submitMessage"
          :class="{'text-green-600': submitSuccess, 'text-red-600': !submitSuccess}"
          class="mt-4 text-center text-sm font-medium px-4 py-2 rounded-lg"
      >
        {{ submitMessage }}
      </div>
    </Transition>
  </form>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';

export default {
  name: 'ContactForm',
  props: {
    formId: {
      type: Number,
      required: true
    },
    pageSlug: {
      type: String,
      required: false
    }
  },
  setup(props) {
    const formFields = ref([
      { id: 'input_3_3', name: 'input_3', type: 'text', label: 'First Name', placeholder: 'First Name', required: true },
      { id: 'input_3_4', name: 'input_4', type: 'text', label: 'Last Name', placeholder: 'Last Name', required: true },
      { id: 'input_3_1', name: 'input_1', type: 'email', label: 'Email', placeholder: 'Email', required: true },
      { id: 'input_3_9', name: 'input_9', type: 'textarea', label: 'Message', placeholder: 'How can I help?', required: true },
      { id: 'input_3_5', name: 'input_5', type: 'hidden', value: props.pageSlug },
      { id: 'input_3_13', name: 'input_13', type: 'hidden', value: 'Contact us' }
    ]);

    const formData = ref({
      input_3: '',
      input_4: '',
      input_1: '',
      input_9: '',
      input_5: props.pageSlug,
      input_13: 'Contact us'
    });

    const isSubmitting = ref(false);
    const submitMessage = ref('');
    const submitSuccess = ref(false);

    const submitForm = async () => {
      isSubmitting.value = true;
      submitMessage.value = '';
      try {
        const response = await axios.post('https://cms.arrify.com/wp-json/arrify-one/v1/lead', {
          ...formData.value,
          form_id: props.formId
        });
        submitMessage.value = 'Form submitted successfully!';
        submitSuccess.value = true;
        formData.value = {
          input_3: '',
          input_4: '',
          input_1: '',
          input_9: '',
          input_5: props.pageSlug,
          input_13: 'Contact us'
        };
      } catch (error) {
        console.error('Error submitting form:', error);
        submitMessage.value = 'Error submitting form. Please try again.';
        submitSuccess.value = false;
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      formFields,
      formData,
      submitForm,
      isSubmitting,
      submitMessage,
      submitSuccess
    };
  }
}
</script>